import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import asyncComponent from "../../util/asyncComponent";

const Routes = ({ match }) => (
  <Switch>
    <Route
      path={`${match.url}/dashboard`}
      component={asyncComponent(() => import("./Dashboard"))}
    />
    <Route
      path={`${match.url}/master/countries`}
      component={asyncComponent(() => import("./MasterData/Countries"))}
    />
    <Route
      path={`${match.url}/master/country_langs`}
      component={asyncComponent(() => import("./MasterData/CountryLangs"))}
    />
    <Route
      path={`${match.url}/master/langs`}
      component={asyncComponent(() => import("./MasterData/Langs"))}
    />
    <Route
      path={`${match.url}/master/specialities`}
      component={asyncComponent(() => import("./MasterData/Specialities"))}
    />
    <Route
      path={`${match.url}/master/doctor_report_configs`}
      component={asyncComponent(() =>
        import("./MasterData/ReportConfigurations")
      )}
    />

    <Route
      path={`${match.url}/content/new`}
      component={asyncComponent(() => import("./Contents/AddContent"))}
    />
    <Route
      path={`${match.url}/content/:id`}
      component={asyncComponent(() => import("./Contents/AddContent"))}
    />
    <Route
      path={`${match.url}/contents`}
      component={asyncComponent(() => import("./Contents/Contents"))}
    />

    <Route
      path={`${match.url}/user/new`}
      component={asyncComponent(() => import("./Users/AddUser"))}
    />
    <Route
      path={`${match.url}/user/:id`}
      component={asyncComponent(() => import("./Users/AddUser"))}
    />
    <Route
      path={`${match.url}/users`}
      component={asyncComponent(() => import("./Users/Users"))}
    />
   
    <Route 
      path={`${match.url}/doctor/new`}
      component={asyncComponent(() => import("./Doctors/AddDoctor"))}
    />
    <Route
      path={`${match.url}/doctor/onboard_url_generate`}
      component={asyncComponent(() => import("./Doctors/DOURLGenerate"))}
    />
    <Route
      path={`${match.url}/doctor/leaves`}
      component={asyncComponent(() => import("./Doctors/DoctorLeave"))}
    />
    <Route
      path={`${match.url}/doctor/:id`}
      component={asyncComponent(() => import("./Doctors/AddDoctor"))}
    />
    
    <Route 
      path={`${match.url}/doctors`}
      component={asyncComponent(() => import("./Doctors/Doctors"))}
    />

    {/* <Route
      path={`${match.url}/doctor/leaves`}
      component={asyncComponent(() => import("./Doctors/DoctorLeave"))}
    /> */}
    {/* <Route 
      path={`${match.url}/doctor/leaves`}
      component={asyncComponent(() => import("./Doctors/NewDoctorLeave"))}
    /> */}
    <Route
      path={`${match.url}/subscription/new`}
      component={asyncComponent(() =>
        import("./Subscriptions/AddSubscription")
      )}
    />
    <Route
      path={`${match.url}/subscription/:id`}
      component={asyncComponent(() =>
        import("./Subscriptions/AddSubscription")
      )}
    />
    <Route
      path={`${match.url}/subscriptions`}
      component={asyncComponent(() => import("./Subscriptions/Subscriptions"))}
    />
    <Route
      path={`${match.url}/payments`}
      component={asyncComponent(() => import("./Payments/Payments"))}
    />

    <Route
      path={`${match.url}/payment/new`}
      component={asyncComponent(() => import("./Payments/AddPayment"))}
    />

    <Route
      path={`${match.url}/business/new`}
      component={asyncComponent(() => import("./Businesses/AddBusiness"))}
    />
    <Route
      path={`${match.url}/business/:id`}
      component={asyncComponent(() => import("./Businesses/AddBusiness"))}
    />
    <Route
      path={`${match.url}/businesses`}
      component={asyncComponent(() => import("./Businesses/Businesses"))}
    />

    <Route
      path={`${match.url}/package/new`}
      component={asyncComponent(() => import("./Packages/AddPackage"))}
    />
    <Route
      path={`${match.url}/package/:id`}
      component={asyncComponent(() => import("./Packages/AddPackage"))}
    />
    <Route
      path={`${match.url}/packages`}
      component={asyncComponent(() => import("./Packages/Packages"))}
    />

    <Route
      path={`${match.url}/promotion/new`}
      component={asyncComponent(() => import("./Promotions/AddPromotion"))}
    />
    <Route
      path={`${match.url}/promotion/:id`}
      component={asyncComponent(() => import("./Promotions/AddPromotion"))}
    />
    <Route
      path={`${match.url}/promotions`}
      component={asyncComponent(() => import("./Promotions/Promotions"))}
    />

    <Route
      path={`${match.url}/feature/new`}
      component={asyncComponent(() => import("./Features/AddFeature"))}
    />
    <Route
      path={`${match.url}/feature/:id`}
      component={asyncComponent(() => import("./Features/AddFeature"))}
    />
    <Route
      path={`${match.url}/features`}
      component={asyncComponent(() => import("./Features/Features"))}
    />

    <Route
      path={`${match.url}/patient/:id`}
      component={asyncComponent(() => import("./Patients/AddPatient"))}
    />
    <Route
      path={`${match.url}/patients`}
      component={asyncComponent(() => import("./Patients/Patients"))}
    />

    <Route
      path={`${match.url}/health_partner/new`}
      component={asyncComponent(() =>
        import("./HealthPartner/AddHealthPartner")
      )}
    />
    <Route
      path={`${match.url}/health_partner/:id`}
      component={asyncComponent(() =>
        import("./HealthPartner/AddHealthPartner")
      )}
    />
     {/* <Route
      path={`${match.url}/doctorShift_view/:id`}
      component={asyncComponent(() =>
        import("./DoctorShifting/subComponents/EditShift")
      )}
    /> */}
    <Route
      path={`${match.url}/health_partners`}
      component={asyncComponent(() => import("./HealthPartner/HealthParthers"))}
    />

    {/*<Route path={`${match.url}/consultation/:id`}
      component={asyncComponent(() => import('./HealthPartner/AddConsultation'))} />*/}
   
    <Route
      path={`${match.url}/consultation/new_consultaion`}
      component={asyncComponent(() => import("./Consultations/AddNewConsultaion"))}
    />
    <Route
      path={`${match.url}/consultation/actual_consultaions`}
      component={asyncComponent(() => import("./Consultations/ActualConsultaionList"))}
    />
    <Route
      path={`${match.url}/consultation/tempory_consultaions`}
      component={asyncComponent(() => import("./Consultations/TemporyConsultaionList"))}
    />
    <Route
      path={`${match.url}/consultations`}
      component={asyncComponent(() => import("./Consultations/Consultations"))}
    />
    
    {/*<Route component={asyncComponent(() => import("app/routes/extraPages/routes/404"))} />*/}
    <Route
      path={`${match.url}/temps`}
      component={asyncComponent(() => import("./Temp/Temp"))}
    />

 {/* Doctor shifting */}
    <Route
      path={`${match.url}/doctor_shifting/list`}
      component={asyncComponent(() =>
        import("./DoctorShifting/DoctorShiftingView")
      )}
    />

    <Route
      path={`${match.url}/doctor_shifting/activeList`}
      component={asyncComponent(() => 
      import("./DoctorShifting/ViewActiveShifts")
      )}/>
   
  
    <Route
      path={`${match.url}/doctor_shifting/create`}
      component={asyncComponent(() =>
        import("./DoctorShifting/DoctorShiftingCreate")
      )}
    />

    <Route
      path={`${match.url}/doctor_shifting/edit`}
      component={asyncComponent(() =>
        import("./DoctorShifting/DoctorShiftingEdit")
      )}
    />

    <Route
      path={`${match.url}/doctor_shifting/shiftCategory`}
      component={asyncComponent(() =>
        import("./DoctorShifting/ShiftCategory")
      )}
    />
    
    {/* Schedular */}
    <Route
      path={`${match.url}/schedular/configAdd`}
      component={asyncComponent(() =>
        import("./Schedular/ConfigAdd")
      )}
    />
    {/* <Route
      path={`${match.url}/schedular/configExpire`}
      component={asyncComponent(() =>
        import("./Schedular/ConfigExpire")
      )}
    /> */}
     <Route
      path={`${match.url}/schedular/sessionView`}
      component={asyncComponent(() =>
        import("./Schedular/SessionView")
      )}
    />

    <Route
      path={`${match.url}/tanent`}
      component={asyncComponent(() => import("./Tanent/tanent"))}
    />
  </Switch>
);

export default withRouter(Routes);